import React, { ChangeEvent } from 'react'
import { Grid, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { ButtonAddAttachment } from './ButtonAddAttachment';

type PropsType = {
  addFile: (e: ChangeEvent<HTMLInputElement>) => void
}

export const AddFirstAttachment = (props: PropsType) => {
  return (
    <Grid container style={{ textAlign: 'center', marginTop: '70px' }} >
      <Grid item xs={12}>
        <AttachFileIcon style={{ fontSize: '70px', color: 'rgba(0,0,0, 0.55)' }} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='caption' >
          No attachments have been added
        </Typography>
      </Grid>
      <Grid container style={{ display: 'flex', margin: '10px', padding: '3px', paddingTop: '4px', fontSize: '14px', justifyContent: 'center', color: 'white' }}>
        <ButtonAddAttachment onClickButton={props.addFile} text='Add attachment'/>
      </Grid>
    </Grid>
  )
}
